import {
    useEffect,
    useState
} from 'react';

import parse from 'html-react-parser';

export default function HeaderThreeCards({ blockInfo }) {
    const [cardInfo, setCardInfo] = useState();
    useEffect(() => {
        if (blockInfo) {
            setCardInfo([
                {
                    header: blockInfo.card1Header,
                    description: blockInfo.card1Text,
                    linkUrl: blockInfo.card1LinkUrl,
                    linkText: blockInfo.card1LinkText,
                    icon: blockInfo.card1Icon?.url
                },
                {
                    header: blockInfo.card2Header,
                    description: blockInfo.card2Text,
                    linkUrl: blockInfo.card2LinkUrl,
                    linkText: blockInfo.card2LinkText,
                    icon: blockInfo.card2Icon?.url
                },
                {
                    header: blockInfo.card3Header,
                    description: blockInfo.card3Text,
                    linkUrl: blockInfo.card3LinkUrl,
                    linkText: blockInfo.card3LinkText,
                    icon: blockInfo.card3Icon?.url
                },
            ])
        }
    }, [blockInfo]);

    return (
        <div style={{color: blockInfo?.textColor, backgroundColor: blockInfo?.backgroundColor}}>
            {/* Header */}
            <div className={"relative pb-32"}>
                <div className="absolute inset-0">
                    {blockInfo?.backgroundImage && (
                        <img
                            className="h-full w-full object-cover"
                            src={blockInfo?.backgroundImage?.url}
                            alt="Background Image"
                            loading='lazy'
                        />
                    )}
                    <div className="absolute inset-0" aria-hidden="true" />
                </div>
                {blockInfo?.headline !== null || blockInfo?.subhead !== null ?
                    <div className="relative mx-auto max-w-7xl py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                        <h1 className="text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl text-center mx-auto" >
                            {blockInfo?.headline}
                        </h1>
                        <div className="mt-6 max-w-4xl text-xl text-center mx-auto">
                            {parse(blockInfo?.subhead ?? '')}
                        </div>
                    </div>
                    :
                    <></>
                }
            </div>
            {/* Overlapping cards */}
            <section
                className={`relative z-10 mx-auto -mt-32 max-w-7xl px-4 pb-12 ${blockInfo?.headline === null && blockInfo?.subhead === null ? "pt-12" : ""}  sm:px-6 lg:px-8 `}
                aria-labelledby="contact-heading"
            >

                <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8">
                    {cardInfo && cardInfo.map((card, index) => (
                        <div key={index} className="flex flex-col rounded-2xl shadow-xl" style={{backgroundColor: blockInfo?.cardBackgroundColor}}>
                            <div className={`relative flex-1 px-6 pb-8 md:px-8 ${card.icon ? 'pt-16' : 'pt-8'}`}>
                                {card.icon && (
                                    <div className={`absolute top-0 ${blockInfo?.iconPosition === 'center' ? 'left-0 right-0 inline-flex justify-center' : ''}`}>
                                        <div className='top-0 inline-block -translate-y-1/2 transform rounded-xl p-4 shadow-lg' style={{backgroundColor: blockInfo?.iconBackgroundColor}}>
                                            <img
                                                className="h-10 w-10 text-white"
                                                src={card.icon}
                                                alt="Icon Badge"
                                                loading='lazy'
                                            />
                                        </div>
                                    </div>
                                )}
                                <h3 className={`text-xl font-medium ${blockInfo?.iconPosition === 'center' ? 'text-center' : ''}`}
                                  style={{color: blockInfo?.cardHeaderTextColor}}>
                                    {card.header}
                                </h3>
                                <div className={`mt-4 text-base ${blockInfo?.iconPosition === 'center' ? 'text-center' : ''}`}
                                  style={{color: blockInfo?.cardTextColor}}>
                                    {parse(card.description ?? '')}
                                </div>
                            </div>
                            {card.linkText && card.linkUrl && (
                                <div className="rounded-bl-2xl rounded-br-2xl bg-gray-50 p-6 md:px-8">
                                    <a href={card.linkUrl} className="text-base font-medium" style={{color: blockInfo?.cardHeaderTextColor}}>
                                        {card.linkText}<span aria-hidden="true"> &rarr;</span>
                                    </a>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}
